import { isRequired } from '../../../utils/validation';

export const initialValues = {
  midLA: '',
};

export const fieldsProps = {
  midLA: {
    name: 'midLA',
    placeholder: 'Masukkan MID LinkAja',
    label: 'MID LinkAja',
  },
};

export const validate = (values = initialValues) => {
  const { midLA } = values;
  const rules = {
    midLA: isRequired(midLA, 'MID LinkAja harus diisi'),
  };

  return rules;
};
